import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

import { getRoleNames, getVisibleAdminSections } from "../types/adminSections";

const AdminLayout: React.FC<{ children: React.ReactNode; isPopupVisible?: boolean }> = ({
                                                                                            children,
                                                                                            isPopupVisible,
                                                                                        }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { roles } = useAuth();

    const roleNames = getRoleNames(roles);
    const visibleMenuItems = getVisibleAdminSections(roleNames);

    function toggleMenu() {
        setIsOpen((p) => !p);
    }

    return (
        <div className="admin-layout">
            {!isPopupVisible && (
                <button className="menu-button" onClick={toggleMenu}>
                    Меню ≡
                </button>
            )}

            <aside className={`sidebar ${isOpen ? "open" : ""}`}>
                <button className="close-button" onClick={toggleMenu}>
                    ×
                </button>

                <nav>
                    <ul>
                        {visibleMenuItems.map((item) => (
                            <li key={item.path}>
                                <Link to={item.path} onClick={toggleMenu}>
                                    {item.label}
                                </Link>
                            </li>
                        ))}

                        {visibleMenuItems.length === 0 && (
                            <li>
                                <span className="admin-muted">Нет доступных разделов</span>
                            </li>
                        )}
                    </ul>
                </nav>
            </aside>

            <main>{children}</main>
        </div>
    );
};

export default AdminLayout;
